document.addEventListener('DOMContentLoaded', () => {
	const form = document.querySelector('form[name="searchpageform"]');
	if (!form) return;

	const input = form.querySelector('.js-catalog-search-input');
	const button = form.querySelector('.js-catalog-search-button');

	if (button && button.getAttribute('type') !== 'button') {
		button.setAttribute('type', 'button');
	}

	function normalizePath(path) {
		path = String(path || '').replace(/^https?:\/\/[^/]+/i, '');
		if (!path.startsWith('/')) path = '/' + path;
		return path;
	}

	function joinUrl(base, path, tail) {
		base = String(base || '').replace(/\/+$/, '');
		path = normalizePath(path);
		const url = `${base}${path}/${tail}`;
		return url.replace(/([^:]\/)\/+/g, '$1'); // // → /
	}

	function performSearch() {
		const action = form.getAttribute('action') || '/search';
		const query = (input?.value || '').trim();
		if (!query) return;

		window.location.href = joinUrl(location.origin, action, encodeURIComponent(query));
	}

	// 1) Перехоплюємо будь-який сабміт (Enter у полі, submit-кнопки, тощо)
	form.addEventListener('submit', (e) => {
		e.preventDefault();
		e.stopPropagation();
		performSearch();
	});

	// 2) Обробляємо клік по іконці-кнопці
	if (button) {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			performSearch();
		});
	}

	if (input) {
		input.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				e.preventDefault();
				performSearch();
			}
		});
	}
});

